<template>
  <div id="app" ondragstart="return false">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "app",
  components: {},
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background: #000 url("./assets/images/home/bg2.png");
  background-size: 100% auto;
  background-position: 0 100%;
  color: #fff;
}
</style>
